import React, { useRef } from 'react';
import NextImage from 'next/image';
import { css } from '@emotion/react';
import { Image } from '@/types/Content/Image';
import LeftArrow from './components/ArrowButton/LeftArrow';
import RightArrow from './components/ArrowButton/RightArrow';

import {
  Name,
  Wrapper,
  Producer,
  ProductSlider,
  HeaderContainer,
} from './styles';

type ProductCarouselProps = {
  title: string;
  images: Array<Image>;
  seller: string;
};

export function ProductCarousel({
  title,
  images,
  seller,
}: ProductCarouselProps): JSX.Element {
  const sliderRef = useRef(null);
  function nextSlider() {
    sliderRef.current?.slickNext();
  }

  function previousSlider() {
    sliderRef.current?.slickPrev();
  }

  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <RightArrow onClick={nextSlider} />,
    prevArrow: <LeftArrow onClick={previousSlider} />,
  };

  return (
    <Wrapper>
      <HeaderContainer>
        <Name>{title}</Name>
      </HeaderContainer>

      <Producer>{seller}</Producer>

      <ProductSlider ref={sliderRef} {...settings}>
        {images?.map((image) => (
          <div
            key={image.url}
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
            `}
          >
            <div
              css={css`
                width: 400px;
                max-height: 400px;
                display: block;
                margin: 0 auto;
                justify-content: center;
                align-items: center;
                position: relative;
              `}
            >
              {!!image.url && (
                <NextImage
                  key={image.url}
                  src={image.url}
                  layout="responsive"
                  objectFit="contain"
                  width={400}
                  height={400}
                />
              )}
            </div>
          </div>
        ))}
      </ProductSlider>
    </Wrapper>
  );
}
